import httpClient, { catchError } from '@emmacare/common/api/httpClient'

import {
  setCaregiverGamificationHistory,
  setCaregiverGamificationVault
} from 'src/store/modules/caregiver'

import {
  GET_CAREGIVER_GAMIFICATION_HISTORY,
  GET_POST_CAREGIVER_GAMIFICATION_VAULT
} from 'src/constants'

export const fetchCaregiverGamificationHistory =
  (config = {}) =>
  async (dispatch) => {
    try {
      const { items = [], meta = {} } = await httpClient.request({
        method: 'get',
        url: {
          pathname: GET_CAREGIVER_GAMIFICATION_HISTORY,
          ...config
        }
      })

      dispatch(setCaregiverGamificationHistory(items))

      return meta
    } catch (err) {
      catchError(err)
    }
  }

export const fetchCaregiverGamificationVault =
  (config = {}) =>
  async (dispatch) => {
    try {
      const vault = await httpClient.request({
        method: 'get',
        url: {
          pathname: GET_POST_CAREGIVER_GAMIFICATION_VAULT,
          ...config
        }
      })

      dispatch(setCaregiverGamificationVault(vault))
    } catch (err) {
      catchError(err)
    }
  }

export const updateCaregiverGamificationVault =
  (config = {}) =>
  async () => {
    const { payload = {}, params = {} } = config

    try {
      await httpClient.request({
        method: 'patch',
        url: {
          pathname: GET_POST_CAREGIVER_GAMIFICATION_VAULT,
          params
        },
        payload
      })

      return true
    } catch (err) {
      catchError(err)

      return false
    }
  }
